import { api } from "@/lib/apiClient";

// Tell the Coach what he just did, so she can pick it up next time they talk.
export const logExperience = (tool, ref = "", title = "") => api.post("/experience", { tool, ref, title }).catch(() => {});
